var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Arrows-/-Arrow-Left-/-Special",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8006797,13.7501574 C14.6301574,13.5762363 14.3533866,13.5762363 14.184176,13.7501574 L11.4361436,16.5516255 L11.4361436,5.15979138 C11.4361436,4.91362609 11.2406988,4.71428571 10.9994753,4.71428571 C10.7594324,4.71428571 10.5638564,4.91362609 10.5638564,5.15979138 L10.5638564,16.5516255 L7.81582399,13.7501574 C7.64530169,13.5762363 7.36997377,13.5762363 7.1993203,13.7501574 C7.028798,13.9240785 7.028798,14.205028 7.1993203,14.3789492 L10.6910923,17.9416567 C10.7318865,17.9817923 10.7802886,18.0152387 10.832757,18.0379822 C10.8865371,18.0593879 10.9429406,18.0714286 10.9994753,18.0714286 C11.0570594,18.0714286 11.1134629,18.0593879 11.167243,18.0379822 C11.2197114,18.0152387 11.2682447,17.9817923 11.3089077,17.9416567 L14.8006797,14.3789492 C14.971202,14.205028 14.971202,13.9240785 14.8006797,13.7501574 Z",
    id: "icon_1017-path",
    fill: "#00a3e0",
    className: "back-icon",
    transform: "translate(11.000000, 11.392857) rotate(-270.000000) translate(-11.000000, -11.392857) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.c5ef7200a11e898e5988e7d7cae769e3.svg";
export { ForwardRef as ReactComponent };